import { Component, Input } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';

@Component({
  selector: 'app-phone-number',
  template: ` @if (phone) {
    <a class="zn-link" [href]="phoneUrl">{{ phone }}</a>
    <a class="ml-2" [href]="textUrl">
      <zenith-icon class="zn-text-size-300" icon-name="comment"></zenith-icon>
    </a>
    }`,
  imports: [ZenithComponentsModule],
  standalone: true
})
export class PhoneNumberComponent {
  @Input() phone: string | null;

  get textUrl() {
    return `sms:${this.phone}`;
  }

  get phoneUrl() {
    return `tel:${this.phone}`;
  }
}
